<template>
  <div>
    <vs-collapse v-if="!empty && !isLoading">
      <div class="flex my-8">
        <label>Convites Ativos</label>
        <div class="badge" :style="{ backgroundColor: color }">
          {{ totalActivities }}
        </div>
      </div>

      <div v-for="(meeting, index) in meetings" :key="`meeting-${index}`">
        <MeetingCard
          v-if="!onExpired(meeting)"
          :waiting="meeting.meeting_status_id == 4"
          :meeting="meeting"
          class="mobile-hidden"
        />

        <MeetingMobileCard
          v-if="!onExpired(meeting)"
          :waiting="meeting.meeting_status_id == 4"
          :meeting="meeting"
          class="sm:hidden"
        />
      </div>

      <div class="flex my-8">
        <label>Convites Expirados/Rejeitados</label>
        <div class="badge" :style="{ backgroundColor: color }">
          {{ totalExpireated }}
        </div>
      </div>

      <div
        v-for="(meeting, index) in meetings"
        :key="`meeting-disabled-${index}`"
      >
        <MeetingCardDisabled
          v-if="onExpired(meeting)"
          :expired="false"
          :meeting="meeting"
          class="mobile-hidden"
        />

        <meeting-mobile-card-disabled
          v-if="onExpired(meeting)"
          :waiting="meeting.meeting_status_id == 4"
          :meeting="meeting"
          class="sm:hidden"
        />
      </div>
    </vs-collapse>
    <MeetingEmptyCard v-if="empty" />
  </div>
</template>

<script>
import MeetingCard from "../../components/dashboard/MeetingCard.vue";
import MeetingMobileCard from "../../components/dashboard/MeetingMobileCard.vue";
import MeetingMobileCardDisabled from "../../components/dashboard/MeetingMobileCardDisabled.vue";
import MeetingEmptyCard from "../../components/dashboard/MeetingEmptyCard.vue";
import MeetingCardDisabled from "../../components/dashboard/MeetingCardDisabled.vue";
import { mapState } from "vuex";
import { compareAsc } from "date-fns";

export default {
  created() {
    window.scroll(0, 0);

    const LABEL = localStorage.getItem("label");

    this.googleAnalytics();

    this.isLoading = true;
    this.$vs.loading({
      text: "Carregando...",
    });
    this.$http
      .get(`/api/v1/talent/${LABEL}/user/talent/meetings`)
      .then((response) => {
        this.isLoading = false;
        this.$vs.loading.close();

        if (
          response.hasOwnProperty("data") &&
          response.data.hasOwnProperty("data") &&
          response.data["data"].length <= 0
        )
          this.empty = true;

        this.meetings = response.data["data"];
      })
      .catch((error) => {
        this.isLoading = false;
        this.$vs.loading.close();
      });
  },
  data() {
    return {
      empty: false,
      isLoading: false,
      meetings: [],
    };
  },
  computed: {
    ...mapState("company", ["company"]),

    color() {
      return this.company.base_hexcolor || "#1551b1";
    },
    totalActivities() {
      let total = 0;
      if (this.meetings != undefined && this.meetings.length > 0) {
        total = this.meetings.filter((item) => !this.onExpired(item)).length;
        return total > 0 ? total : 0;
      }
      return total;
    },

    totalExpireated() {
      let total = 0;

      if (this.meetings != undefined && this.meetings.length > 0) {
        total = this.meetings.filter((item) => this.onExpired(item)).length;
        return total > 0 ? total : 0;
      }
      return total;
    },
  },
  methods: {
    onExpired(meeting) {
      const date_splited = meeting.date.split("/");
      const time_splited = meeting.time.split(":");
      const meeting_date = new Date(
        date_splited[2],
        parseInt(date_splited[1]) - 1,
        date_splited[0],
        time_splited[0],
        time_splited[1],
        time_splited[2]
      );

      return compareAsc(meeting_date, new Date()) == -1 ? true : false;
    },

    googleAnalytics() {
      const { company_label } = this.$router.history.current.params;
      this.$ga.page(`${company_label}/meeting`);
    },
  },
  components: {
    MeetingCard,
    MeetingCardDisabled,
    MeetingEmptyCard,
    MeetingMobileCard,
    MeetingMobileCardDisabled,
  },
};
</script>

<style lang="scss">
.coll-header {
  display: flex;
  align-items: center;
}
.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: white;
  margin-left: 0.5rem;
  border-radius: 25%;
  background-color: blueviolet;
}
</style>
